import React from "react";
import "../../css/components/RowFlex.css";

const RowFlex = ({ left, right }) => (
  <div className="row-flex-container">
    <div className="row-flex-left">{left}</div>
    <div className="row-flex-right">{right}</div>
  </div>
);

export default RowFlex;
